import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Teamdetails = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Team Member Details</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Team Member Details</li>
          </ul>
        </div>
      </section>

      <div className="ul-section-spacing">
        <div className="ul-container">
          <div className="ul-team-details">
            <div className="row justify-content-between gx-0 gy-3">
              <div className="col-md-5">
                <div className="ul-team-details-img wow animate__fadeInUp">
                  <img
                    src="/assets/new-img/new/cardiologist-in-white-uniform-consulting-female-pa-2024-11-26-11-46-35-utc.JPG"
                    alt="team member image"
                  />
                </div>
              </div>

              <div className="col-md-6">

                <div className="txt wow animate__fadeInUp">
                  <h3 className="ul-team-details-name ul-section-title">
                    Danial Frankie
                  </h3>
                  <h6 className="ul-team-details-role">Co-Founder</h6>
                  <p className="ul-team-details-descr">
                    Adipiscing elit. Mauris viverra nisl quis mollis laoreet. Ut
                    eget lacus a felis accumsan pharetra in dignissim enim. In
                    amet odio mollis urna aliquet volutpat. Sed bibendum nisl
                    vehicula imperdiet imperdiet, augue massa fringilla.
                  </p>

                  <ul className="ul-team-details-infos">
                    <li className="ul-team-details-info">
                      <a href="tel:2085550112"
                        ><i className="flaticon-telephone-call"></i>
                        +208-555-0112</a
                      >
                    </li>
                    <li className="ul-team-details-info">
                      <a href="mailto:thomas.tatum@example.com"
                        ><i className="flaticon-email"></i>
                        thomas.tatum@example.com</a
                      >
                    </li>
                  </ul>

                  <div className="ul-team-details-socials">
                    <a href="https://facebook.com/pathio" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="flaticon-facebook"></i></a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="flaticon-instagram"></i></a>
                    <a href="https://linkedin.com/company/pathio" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="flaticon-linkedin-big-logo"></i></a>
                    <a href="https://twitter.com/pathio" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="flaticon-twitter-1"></i></a>
                  </div>

                  <div className="ul-team-details-experiences">
                    <h3 className="ul-donation-details-summary-title">
                      Experience Area
                    </h3>

                    <div className="experiences-wrapper">
                      <div className="ul-team-details-experience">
                        <h6 className="experience-title">Productivity</h6>
                        <div className="ul-donation-progress-2">
                          <div className="ul-progress-container">
                            <div
                              className="skill-progressbar ul-progressbar"
                              data-ul-progress-value="90"
                            >
                              <div
                                className="skill-progress-label ul-progress-label"
                              >
                                00%
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ul-team-details-experience">
                        <h6 className="experience-title">Digital Marketing</h6>
                        <div className="ul-donation-progress-2">
                          <div className="ul-progress-container">
                            <div
                              className="skill-progressbar ul-progressbar"
                              data-ul-progress-value="87"
                            >
                              <div
                                className="skill-progress-label ul-progress-label"
                              >
                                00%
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ul-team-details-experience">
                        <h6 className="experience-title">Technology</h6>
                        <div className="ul-donation-progress-2">
                          <div className="ul-progress-container">
                            <div
                              className="skill-progressbar ul-progressbar"
                              data-ul-progress-value="65"
                            >
                              <div
                                className="skill-progress-label ul-progress-label"
                              >
                                00%
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ul-team-details-contact">
                    <h3 className="ul-donation-details-summary-title">
                      Message With Me
                    </h3>
                    <form action="#" className="ul-contact-form ul-form">
                      <div className="row row-cols-2 row-cols-xxs-1 ul-bs-row">
                        <div className="col">
                          <div className="form-group">
                            <input
                              type="text"
                              name="name"
                              id="ul-contact-name"
                              placeholder="Your Name"
                            />
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <input
                              type="email"
                              name="email"
                              id="ul-contact-email"
                              placeholder="Email Address"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <input
                              type="tel"
                              name="phone"
                              id="ul-contact-phone"
                              placeholder="Phone Number"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <textarea
                              name="message"
                              id="ul-contact-msg"
                              placeholder="Type your message"
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-12">
                          <button className="ul-btn">
                            <i
                              className="flaticon-fast-forward-double-right-arrows-symbol"
                            ></i>
                            Get in Touch
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

      <Footer />
    </>
  );
};

export default Teamdetails;
